/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAlignDataAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 5H2V3h20zm0 4H2V7h20zM8 13H2v-2h6zm4.03 1a.736.736 0 0 0 .05.052c.13.123.373.28.756.434.76.304 1.878.514 3.164.514s2.404-.21 3.164-.514c.383-.153.625-.31.756-.434a.785.785 0 0 0 .05-.052.761.761 0 0 0-.05-.052c-.13-.123-.373-.28-.756-.434C18.404 13.21 17.286 13 16 13s-2.404.21-3.164.514c-.383.153-.625.31-.756.434a.761.761 0 0 0-.05.052zM20 16.305l-.093.038c-1.05.42-2.432.657-3.907.657s-2.857-.237-3.907-.657a6.972 6.972 0 0 1-.093-.038v2.362c0 .025.061.358.887.743.745.348 1.845.59 3.113.59s2.368-.242 3.113-.59c.826-.385.887-.718.887-.743zM22 14v4.667c0 1.263-1.058 2.097-2.042 2.556C18.895 21.72 17.494 22 16 22c-1.493 0-2.893-.28-3.958-.777-.984-.46-2.042-1.293-2.042-2.556V14c0-.64.328-1.148.706-1.505.375-.355.865-.629 1.387-.838C13.143 11.237 14.525 11 16 11s2.857.237 3.907.657c.522.21 1.012.483 1.387.838.378.357.706.865.706 1.505zm-1.993-.05a.02.02 0 0 1 .002-.005l-.002.006zm-8.014 0-.002-.005.002.006zM8 17H2v-2h6zm0 4H2v-2h6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAlignDataAlt as AlignDataAlt };
